

// jQuery(document).on('gform_confirmation_loaded', function(event, formId){
//     if (formId == 1){
//         console.log(jQuery('#download-course-material'));
//         jQuery('#download-course-material').get(0).click();

//     }

// });

jQuery(document).ready(function($){
    if($('#download-course-material').length > 0){
        $('#download-course-material').get(0).click();
    }

})

jQuery(document).ready(function($){

    if ($('.resource-section .video-col').length > 1){

        $('.video-col').addClass('multiple-videos');

        // $('.decorative-img-holder').find('.image-right').hide();
        // $('.decorative-img-holder').find('.image-left').hide();


    }

    $('.single-course-section .courses-list-box li').click(function(){
        if (!$(this).hasClass('active')){
            $('.resource-panel-section div.play-video .embed-responsive').remove();
            $('.resource-panel-section div.play-video img').show();
            $('.resource-panel-section div.play-video .fa-play').show();
        }
    });

    $('.play-video').click(function(event){
        event.stopPropagation();

        var random_number = $(this).closest('.decorative-img-holder').data('random-number');
        var video_html = video_object[random_number];

        console.log(video_object);
        console.log(video_html);

        
        
        $(this).closest('.decorative-img-holder').addClass('video-showing')

        $(this).closest('.decorative-img-holder').find('.fa-play').hide();
        $(this).closest('.decorative-img-holder').find('img').not('.image-right').not('.image-left').hide();
        $(this).closest('div.play-video').append(video_html);

    });

    $('.load-hide-more').click(function(){
        console.log('clicked load hide more');
        $(this).closest('.course-session').find('.hidden-info-sessions').slideToggle();

        if ($(this).find('.arrow-icon').hasClass('fa-arrow-alt-down')){
            $(this).find('.arrow-icon').removeClass('fa-arrow-alt-down').addClass('fa-arrow-alt-up');
            $(this).find('.inner-text').text('hide');
        }
        else{
            $(this).find('.arrow-icon').removeClass('fa-arrow-alt-up').addClass('fa-arrow-alt-down');
            $(this).find('.inner-text').text('load more');
        }
    });


        
        $('.instructor-slider-container').slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            prevArrow: '<i class="slick-arrow left fas fa-chevron-left"></i>',
            nextArrow: '<i class="slick-arrow right fas fa-chevron-right"></i>',

        });


    adjustStickyContainerHeight();

    $(window).resize(function(){
        adjustStickyContainerHeight();
    })

    function adjustStickyContainerHeight(){
        // var sectionHeights = $('.single-course-sections').outerHeight();

        // var is_sticky = window.matchMedia("(min-width: 992px)");

        // if (is_sticky.matches){

        //     $('.single-course-sticky-container').css('height', sectionHeights + 'px');
        // }

        // else{

        //     $('.single-course-sticky-container').css('height', 'auto');
        // }



      
    }

        /*-------------------------------------*\ 
                    SCROLL STUFF ON 
        \*-------------------------------------*/
        $(window).scroll(function(){

            controlSidebar();

        })

        function controlSidebar(){

            var sections = document.querySelectorAll('.single-course-section');
            var exit_loop = false;

            $.each(sections, function(index,value){
                    if (isInViewport(value)){
                        $('.course-nav li').removeClass('active');
                        $('.course-nav li[data-scroll-to="'+$(this).attr('id')+'"]').addClass('active');
                        return false;
                    }

                    // if (exit_loop){
                    //     break;
                    // }

                //}
            });
        }

        var isInViewport = function (elem) {

            var bounding = elem.getBoundingClientRect();
            return (
                bounding.top >= 0 &&
                bounding.left >= 0 &&
                // bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                bounding.right <= (window.innerWidth || document.documentElement.clientWidth)
            );
        };

        $('.course-nav li').click(function(){
            var id = $(this).data('scroll-to');

            var section = $('#'+id);
            $('html, body').animate({
                scrollTop: section.offset().top - 100
            }, 500)

        });

        $('#free-consultation-pop-up .exit').click(function(){
            $('#free-consultation-pop-up').hide();
            $('#free-consultation-pop-up').addClass('hidden');

        });

        controlConsultationMessage();

        $(window).scroll(function(){
            controlConsultationMessage();
        });

        function controlConsultationMessage(){
            var scroll_top = $(document).scrollTop();

            if (scroll_top > 150 &&  !$('#free-consultation-pop-up').hasClass('hidden') ){
                $('#free-consultation-pop-up').show();
            }
            else{
                $('#free-consultation-pop-up').hide();
            }
            
        }

        $('#resource-panel-section .courses-list-box').matchHeight({target: $('#resource-panel-section .course-description')})
    
});